module.exports = __webpack_public_path__ + "img/20080.a5db6047.png";